import DataGridComponent from 'components/DataGrid/DataGridComponent';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { APIEndpoints } from 'helpers/APILists';
import {
    alertNotificationApiEndpoint, alertNotificationHeaderData,
    alertNotificationInitialState, alertNotificationSearchState
} from './AlertNotification.data';
import { trackErrors } from '../helper';
import { MESSAGE_TYPE } from 'journeys/common/common.constants';
import { AdminConstants } from '../../AdminScreen.constants';
import AlertNotificationForm from './AlertNotificationForm';

const addTitle = 'Add New Record for Alert Notification';
const editTitle = 'Edit Record for Alert Notification';
const formatDateIfExists = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = d.toLocaleString('en-GB', { month: 'short' });
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
};

const AlertNotification = () => {
    const apiEndpoints = alertNotificationApiEndpoint;
    const [showModal, setShowModal] = useState(false);
    const [editRowData, setEditRowData] = useState(alertNotificationInitialState);
    const [modalTitle, setModalTitle] = useState(addTitle);
    const [refreshDatagrid, setRefreshDatagrid] = useState(false);
    const [bpRegionOptions, setBpRegionOptions] = useState([]);
    const [rowDetails, setRowDetails] = useState({
        columnName: 'RowId',
        rowNumber: ''
    });

    useEffect(() => {
        axios.get(APIEndpoints.GetMratGroupMappings)
            .then((res) => {
                const allRegions = res.data.filter(y => y.Status === AdminConstants.LIVE_STATUS).map(x => ({ BpRegion: x.BpRegion, BpRegionAlias: x.BpRegionNameAlias }));
                setBpRegionOptions([{ BpRegion: 'ALL' }, ...allRegions]);
            })
            .catch((err) => {
                trackErrors({
                    messageType: MESSAGE_TYPE.ERROR,
                    message: err.message,
                    exception: err
                });
            });
    }, []);
    const parseData = async (data) => {
        try {
            return data.map(item => ({
                ...item,
                AlertStartDate: formatDateIfExists(item.AlertStartDate),
                AlertEndDate: formatDateIfExists(item.AlertEndDate),
            }));
        } catch (err) {
            trackErrors({
                messageType: MESSAGE_TYPE.ERROR,
                message: err.message,
                exception: err
            });
            throw err;
        }
    };

    const handleEditRecord = (obj) => {
        const rowData = obj.row;
        setModalTitle(editTitle);
        setShowModal(true);
        setEditRowData((prev) => ({
            ...prev,
            ...rowData
        }));
    };
    const handleAddRecord = () => {
        setEditRowData(alertNotificationInitialState);
        setModalTitle(addTitle);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleRecordSubmit = (newId) => {
        setRefreshDatagrid(prev => !prev);
        setRowDetails(prev => ({ ...prev, rowNumber: newId }));
    };

    return (
        <>
            <DataGridComponent
                headerData={alertNotificationHeaderData}
                apiEndpoint={apiEndpoints.read}
                editRecord={handleEditRecord}
                addRecord={handleAddRecord}
                rowDetails={rowDetails}
                dataParser={parseData}
                initialData={alertNotificationSearchState}
                refreshDatagrid={refreshDatagrid}
            />

            {showModal
                && (
                    <AlertNotificationForm
                        isOpen={showModal}
                        onClose={handleModalClose}
                        title={modalTitle}
                        rowData={editRowData}
                        onRecordSubmit={handleRecordSubmit}
                        bpRegionOptions={bpRegionOptions}
                    />
                )}
        </>
    );
};

export default AlertNotification;
